// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  background-color: white;
  padding: 15px;
}
.button-row {
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/email-buttons-panel/email-buttons-panel.component.less"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,aAAA;AACJ;AACA;EACI,oBAAA;AACJ","sourcesContent":[".main {\n    background-color: white;\n    padding: 15px;\n}\n.button-row {\n    padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
